var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"root"},on:{"click":_vm.goBack}},[_vm._v(" "+_vm._s(_vm.$cte("common.error"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }